module.exports = __webpack_public_path__ + "static/media/white-ribbon.ac22276f.jpg";